import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';

const ELEMENT_DATA: any[] = [
  { quote_no: 'ARCU12223_FC', quoted_on: '12-Aug-22 10:10 (Suresh T)', pick_up: '$1600', free_days: 50, per_diem: '$7', dpp: '$100', replacement: '$6000 ( 5% Dept Annual) Max Dep.: 60%', actions: '' },
  { quote_no: 'ARCU12223_FC', quoted_on: '16-Aug-22 10:10 (Suresh T)', pick_up: '$1500', free_days: 60, per_diem: '$7', dpp: '$100', replacement: '$6000 ( 5% Dept Annual) Max Dep.: 60%', actions: '' },
];

@Component({
  selector: 'logzy-quote-history',
  templateUrl: './quote-history.component.html',
  styleUrls: ['./quote-history.component.scss']
})
export class QuoteHistoryComponent implements OnInit {

  // displayedOneWayColumns: string[] = ['quote_no', 'created_at', 'pickup_charge', 'free_days', 'per_diem', 'dpp_charge', 'new_build_charge', 'quote_valid_till', 'actions'];
  // displayedTradeColumns: string[] = ['quote_no', 'created_at', 'price', 'color_preference', 'manufacturing_year', 'quote_valid_till', 'actions'];
  displayedOneWayColumns: string[] = ['quote_no', 'created_at', 'quote_valid_till', 'created_by','actions'];
  displayedTradeColumns: string[] = ['quote_no', 'created_at', 'quote_valid_till','created_by', 'actions'];

  dataSource = ELEMENT_DATA;
  quoteHistoryList;
  requestType;

  @Input() header: boolean = false;

  @Input()
  getHistory = new BehaviorSubject(null);
  downloadUrl = ApiRoutes.LeadRequest;

  constructor(private requestService: RequestApiService) { }

  ngOnInit(): void {
    this.getHistory.subscribe(item => {
      this.requestType = this.requestService.selectedRequest.request_type;
      if (item) {
        this.getPreviousQuotes();
      }
    });
    this.requestType = this.requestService.selectedRequest.request_type;
    this.getPreviousQuotes();
  }

  getPreviousQuotes() {
    this.requestService.getQuoteHistory(this.requestService.selectedRequest.id).subscribe({
      next: response => {
        this.quoteHistoryList = new MatTableDataSource(response.results);
        console.log("this.quoteHistoryList",this.quoteHistoryList)
        return response;
      },
      error: error => {
        console.log(error);
        return error;
      }
    })
  }
  downloadQuote(element) {
    if (this.requestService.selectedRequest.request_type.dev_name == 'one_way') {
      window.open(`${this.downloadUrl}request_quotes/pdf/oneway/${element.id}/`, '_blank')
    }
    if (this.requestService.selectedRequest.request_type.dev_name == 'buy_sell') {
      window.open(`${this.downloadUrl}request_quotes/pdf/trade/${element.id}/`, '_blank')
    }
    if (this.requestService.selectedRequest.request_type.dev_name == 'lease') {
      window.open(`${this.downloadUrl}request_quotes/pdf/lease/${element.id}/`, '_blank')
    }
  }


}
